export default __webpack_public_path__ + "static/media/Background_00019.95cc3074.png";